import { Component } from 'react';
// @ts-expect-error untyped import
import { addHsTrackingCode, removeHsTrackingCode } from '../../utils/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withConsentListeners(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.handleIframeMessaging = event => {
        if (!event || !event.data || event.data.type !== 'privacy-consent' || typeof event.data.shouldTrackAnalytics !== 'boolean') return;
        const {
          shouldTrackAnalytics
        } = event.data;
        this.setState({
          shouldTrackAnalytics
        });
      };
      this.state = {
        shouldTrackAnalytics: true
      };
    }
    componentDidMount() {
      const {
        embedded
      } = this.props;
      if (embedded) {
        window.addEventListener('message', this.handleIframeMessaging);
        window.parent.postMessage('readyForConsentListener', '*');
      } else {
        const _hsp = window._hsp = window._hsp || [];
        _hsp.push(['addPrivacyConsentListener', consent => {
          const allowed = consent.allowed;
          const currentCategories = consent.categories;
          const shouldTrackAnalytics = allowed || currentCategories.analytics;
          this.setState({
            shouldTrackAnalytics
          });
        }]);
      }
    }
    componentWillUnmount() {
      const {
        embedded
      } = this.props;
      if (embedded) {
        window.removeEventListener('message', this.handleIframeMessaging);
      }
    }
    componentDidUpdate() {
      const {
        availabilityFetchSuccess,
        embedded,
        portalId
      } = this.props;
      const {
        shouldTrackAnalytics
      } = this.state;
      if (shouldTrackAnalytics !== undefined && availabilityFetchSuccess) {
        if (shouldTrackAnalytics) {
          addHsTrackingCode(portalId, embedded);
        } else {
          removeHsTrackingCode();
        }
      }
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  };
}